import React from "react";
import { Helmet } from 'react-helmet-async';

const EkonomiPage = () => (
    <>
        <Helmet>
            <title>Ekonomi</title>
        </Helmet>
        <div>
            <h1>Ekonomi</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    </>
);

export default EkonomiPage;
